import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { stripesShape, withStripes, TitleManager } from '@folio/stripes/core';
import { ConfigManager } from '@folio/stripes/smart-components';
import { Loading } from '@folio/stripes/components';

import SelfCheckoutSettingsForm from './SelfCheckoutSettingsForm';

export const DEFAULT_INITIAL_CONFIG = {
  supportedMessages: {
    LOGIN: true,
    SC_ACS_STATUS: true,
    PATRON_INFORMATION: false,
    CHECKOUT: false,
    CHECKIN: false,
    RENEW: false,
    RENEW_ALL: false,
    PATRON_STATUS_REQUEST: false,
    END_PATRON_SESSION: false,
    FEE_PAID: false,
    ITEM_INFORMATION: false,
    BLOCK_PATRON: false,
    ITEM_STATUS_UPDATE: false,
    PATRON_ENABLE: false,
    HOLD: false,
    REQUEST_SC_ACS_RESEND: false,
  },
  statusUpdateOk: false,
  offlineOk: false,
  patronPasswordVerificationRequired: true,
  invalidCheckinStatuses: '',
};

export const getInitialValues = (settings) => {
  if (!settings || settings.length === 0) {
    return DEFAULT_INITIAL_CONFIG;
  }

  try {
    const config = JSON.parse(settings[0].value);
    const supportedMessages = {};

    if (config.supportedMessages && Array.isArray(config.supportedMessages)) {
      config.supportedMessages.forEach((msg) => {
        supportedMessages[msg.messageName] = msg.isSupported === 'Y';
      });
    }

    return {
      ...DEFAULT_INITIAL_CONFIG,
      ...config,
      supportedMessages,
    };
  } catch (e) {
    return DEFAULT_INITIAL_CONFIG;
  }
};

export const normalize = (values) => {
  const supportedMessages = [];

  Object.entries(values.supportedMessages || {}).forEach(
    ([messageName, isSupported]) => {
      supportedMessages.push({
        messageName,
        isSupported: isSupported ? 'Y' : 'N',
      });
    },
  );

  return JSON.stringify({
    ...values,
    supportedMessages,
  });
};

class SelfCheckoutSettings extends React.Component {
  static propTypes = {
    stripes: stripesShape.isRequired,
    intl: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.configManager = props.stripes.connect(ConfigManager);
  }

  render() {
    const { formatMessage } = this.props.intl;

    return (
      <TitleManager
        page={formatMessage({ id: 'ui-circulation.settings.title.general' })}
        record={formatMessage({
          id: 'ui-circulation.settings.selfCheckout.tenantConfig.title',
        })}
      >
        <this.configManager
          label={formatMessage({
            id: 'ui-circulation.settings.selfCheckout.tenantConfig.title',
          })}
          moduleName="edge-sip2"
          configName="acsTenantConfig"
          getInitialValues={getInitialValues}
          configFormComponent={SelfCheckoutSettingsForm}
          stripes={this.props.stripes}
          onBeforeSave={normalize}
        />
      </TitleManager>
    );
  }
}

export default injectIntl(withStripes(SelfCheckoutSettings));
